import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import GLOBE from 'vanta/dist/vanta.globe.min';
import * as THREE from 'three';
import './Cooperate.scss';

const Cooperate: React.FC = () => {
  const { t } = useTranslation();
  const vantaRef = useRef<HTMLDivElement | null>(null);
  const vantaEffect = useRef<any>(null);

  useEffect(() => {
    if (!vantaRef.current || vantaEffect.current) {
      return;
    }

    try {
      (window as any).THREE = THREE;
      vantaEffect.current = GLOBE({
        el: vantaRef.current,
        THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        backgroundColor: 0x001529,
        color: 0x69c0ff,
        color2: 0xffffff,
        size: 1.0,
      });
    } catch (error) {
      console.error('Vanta initialization error:', error);
    }

    return () => {
      try {
        if (vantaEffect.current) {
          vantaEffect.current.destroy();
          vantaEffect.current = null;
        }
      } catch (error) {
        console.warn('Vanta cleanup error:', error);
      }
    };
  }, []);

  return (
    <div className="cooperate-page">
      <div className="cooperate-bg" ref={vantaRef} aria-hidden="true" />
      <div className="cooperate-content">
        <h1>{t('cooperate')}</h1>
        <p>{t('cooperateIntro')}</p>
        <ul>
          {(t('cooperateList', { returnObjects: true }) as string[]).map((item: string, index: number) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Cooperate;